import { Attribute, BelongsTo, JsonApiModel, JsonApiModelConfig } from 'angular2-jsonapi'
import { ArrayConverter } from '../../core/converters/array.converter'
import { AgrupamentoConverter } from '../converters/agrupamento.converter'
import { EmpresaQueVendeComCartoes } from '../empresa-que-vende-com-cartoes.model'
import { Agrupamento } from './agrupamento.model'
import { Antecipacao } from './antecipacao.model'
import { Extrato } from './extrato.interface'

@JsonApiModelConfig({
    type: 'extratos-de-antecipacoes'
})
export class ExtratoDeAntecipacoes extends JsonApiModel implements Extrato<Antecipacao> {
    @Attribute() inicio: Date
    @Attribute() fim: Date
    @Attribute() idDaEmpresa: number
    @Attribute({
        converter: new ArrayConverter(new AgrupamentoConverter(Antecipacao))
    })
    agrupamentos: Agrupamento<Antecipacao>[]

    @BelongsTo() empresaQueVendeComCartoes: EmpresaQueVendeComCartoes
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/collect/extrato/extrato-de-antecipacoes.model.ts